module.exports = __webpack_public_path__ + "static/media/hero-banner-@2x.421f0ac9.png";